import React, { useEffect, useState } from 'react';
import Presenter from 'components/presenters/campaign/list/CampaignMainListTop'

export default function CampaignMainListTop({initTab, onSelect}) {
  const [currTab, setCurrTab] = useState('joinable');
  useEffect(()=>{
    if(['joinable','complete','progress'].includes(initTab))
    {
      setCurrTab(initTab) 
    }

  },[initTab])

  return (
    <Presenter currTab={currTab} onSelect={(newTab)=>{
      if(onSelect)
      {
        onSelect(newTab)
      }
      setCurrTab(newTab)
    }}/> 
  );
} 